import { useQuery } from 'react-query';
import { queryConsultationSummaryENT } from './useConsultationSummaryENT.query';
import {
  ConsultationSummaryENTResponse,
  UseConsultationSummaryENTOptions,
} from './useConsultationSummaryENT.types';

export const CONSULTATION_SUMMARY_ENT_QUERY_KEY = 'CONSULTATION_SUMMARY_ENT';

export const useConsultationSummaryENT = (
  consultationId: number,
  options?: UseConsultationSummaryENTOptions
) => {
  return useQuery<ConsultationSummaryENTResponse, Error>(
    CONSULTATION_SUMMARY_ENT_QUERY_KEY,
    () => queryConsultationSummaryENT(consultationId),
    {
      retry: false,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
};
